// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import Accordion from "@insite/mobius/Accordion";
import AccordionSection from "@insite/mobius/AccordionSection";
import { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import GridContainer from "@store/MobiusOverrides/GridContainer/GridContainer";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import React, { FC, useContext, useState } from "react";
import { css } from "styled-components";

export interface OrderDetailMessage {
    Body: string;
    Username: string;
    CreatedOn: Date;
}

interface Props extends WidgetProps {}

export interface OrderDetailsMessagesStyles {
    orderMessagesWrapper?: InjectableCss;
    messagesContainer?: GridContainerProps;
    messageGridItem?: GridItemProps;
    userNameText?: TypographyPresentationProps;
    messageDateText?: TypographyPresentationProps;
    messageBodyText?: TypographyPresentationProps;
}

export const orderDetailsMessagesStyles: OrderDetailsMessagesStyles = {
    orderMessagesWrapper: {
        css: css`
            padding-top: 2rem;
        `,
    },
    messagesContainer: {
        gap: 20,
        css: css`
            ${GridOffset} {
                margin-bottom: ${pxToRem(20)};
                max-height: ${pxToRem(500)};
                overflow-y: scroll;
            }
            ${GridItemStyle} {
                margin: ${pxToRem(0, 10)};
                padding: ${pxToRem(10, 0)};
                border-bottom: 1px solid ${getColor("common.border")};
            }
        `,
    },
    messageGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    userNameText: {
        weight: "bold",
    },
    messageBodyText: {
        css: css`
            margin-top: ${pxToRem(10)};
        `,
    },
};

const styles = orderDetailsMessagesStyles;

const OrderDetailsMessages: FC<Props> = () => {
    const { value: order, isLoading } = useContext(OrderStateContext);

    if (!order || isLoading || !order.properties.messages) {
        return null;
    }

    const messageCollection: OrderDetailMessage[] = JSON.parse(order.properties.messages);
    const sortedMessages = sortBy(messageCollection || [], ["createdOn"]).reverse();

    return (
        <StyledWrapper {...styles.orderMessagesWrapper}>
            <Accordion headingLevel={2}>
                <AccordionSection title={`${translate("Messages")} (${messageCollection.length})`}>
                    <GridContainer {...styles.messagesContainer}>
                        {sortedMessages.map(message => (
                            <GridItem key={message.CreatedOn.toString()} {...styles.messageGridItem}>
                                <Typography {...styles.userNameText}>{message.Username}</Typography>
                                <Typography {...styles.messageDateText}>
                                    <LocalizedDateTime
                                        dateTime={message.CreatedOn}
                                        options={{
                                            year: "numeric",
                                            month: "numeric",
                                            day: "numeric",
                                            hour: "numeric",
                                            minute: "numeric",
                                        }}
                                    />
                                </Typography>
                                <Typography {...styles.messageBodyText}>{message.Body}</Typography>
                            </GridItem>
                        ))}
                    </GridContainer>
                </AccordionSection>
            </Accordion>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsMessages,
    definition: {
        group: "Order Details",
        displayName: "Order Details Messages",
        allowedContexts: ["OrderDetailsPage"],
    },
};

export default widgetModule;
